import { render, staticRenderFns } from "./FormHeaders.vue?vue&type=template&id=609e2ad8&scoped=true&"
import script from "./FormHeaders.vue?vue&type=script&lang=js&"
export * from "./FormHeaders.vue?vue&type=script&lang=js&"
import style0 from "./FormHeaders.vue?vue&type=style&index=0&id=609e2ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609e2ad8",
  null
  
)

export default component.exports